import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {RecordData} from "../../../../types/records-table.types";
import {baseUrl} from "../../../../constants/base-url";
import {bloggerModalResourceType, bloggerProfilesResourceType} from "../configs/blogger-modal-config";
import {BloggerCanBeUnbindParams} from "../types/blogger-card.types";
import {BloggerDeduplicationProps, BloggerSearchDuplicatesProps} from "../types/blogger-deduplication-modal.types";
import {bloggerDeduplicationPath, bloggerResourceType} from "../configs/blogger-deduplication-modal-config";
import {CreateProfileBloggerParams} from "../types/create-profile-blogger-modal.types";
import {MassOffersParams} from "../types/blogger-mass-offer-modal.types";

@Injectable({
  providedIn: 'root'
})
export class BloggerModalApiService {
  private http: HttpClient = inject(HttpClient);

  public getBloggerCard(id: number): Observable<RecordData> {
    return this.http.get<RecordData>(`${baseUrl}/${bloggerModalResourceType.path}/card/${id}`)
  }

  public searchBloggers(search: string): Observable<Array<RecordData>> {
    return this.http.get<Array<RecordData>>(`${baseUrl}/${bloggerModalResourceType.path}/search`, {
      params: { search }
    })
  }

  public isBloggerCanBeUnbind({ path, id }: BloggerCanBeUnbindParams): Observable<boolean> {
    return this.http.get<boolean>(`${baseUrl}/${path}/check-can-remove-blogger/${id}`);
  }

  public deduplicationBlogger(bloggerDeduplicationProps: BloggerDeduplicationProps): Observable<void> {
    const { currentBloggerId, duplicateBloggerId } = bloggerDeduplicationProps;
    return this.http.delete<void>(`${baseUrl}/${bloggerResourceType.path}/${bloggerDeduplicationPath}/${currentBloggerId}?duplicateBloggerId=${duplicateBloggerId}`)
  }

  public searchDuplicates({ path, originalId, search }: BloggerSearchDuplicatesProps): Observable<Array<RecordData>> {
    return this.http.get<Array<RecordData>>(`${baseUrl}/${path}/duplicates?originalId=${originalId}`, {
      params: {
        search
      }
    });
  }

  public updateRating(id: number): Observable<void> {
    return this.http.post<void>(`${baseUrl}/${bloggerModalResourceType.path}/${id}/rating/update`, {});
  }

  public createProfileBlogger({ bloggerId, url }: CreateProfileBloggerParams): Observable<RecordData> {
    return this.http.post<RecordData>(`${baseUrl}/${bloggerProfilesResourceType.path}?bloggerId=${bloggerId}`, { url: url });
  }

  public deleteProfileBlogger(id: number): Observable<void> {
    return this.http.delete<void>(`${baseUrl}/${bloggerProfilesResourceType.path}/${id}`);
  }

  public massOffers(massOffersParams: MassOffersParams): Observable<void> {
    return this.http.post<void>(`${baseUrl}/${bloggerModalResourceType.path}/offers/send`, {}, {
      params: massOffersParams
    });
  }

  public toggleBlacklistBlogger(path: string): Observable<void> {
    return this.http.post<void>(`${baseUrl}/bloggers/blacklist/${path}`, {});
  }
}
